import Vue from 'vue';
import axios from './http-axios.js'; // Use if need for HTTP header customisations
import store from '../store/store';

import Axios from 'axios';

import { MFA_TYPE } from '../constants.js';

const debugConsole = false;

const apiDomain = process.env.VUE_APP_LOCAL_ENV ? process.env.VUE_APP_API_DOMAIN_LOCAL
  : process.env.VUE_APP_STAGING_ENV ? process.env.VUE_APP_API_DOMAIN_TESTING
  : process.env.VUE_APP_UAT_ENV ? process.env.VUE_APP_API_DOMAIN_UAT
  : process.env.VUE_APP_API_DOMAIN;

const DASHBOARD_URL = process.env.VUE_APP_STAGING_ENV ? 'https://dashboard.triple-a.work'
  : 'https://dashboard.triple-a.io';

Vue.mixin({
  methods: {
    needsMockData(email) {
      if (debugConsole)
        window.console.debug(
          'needsMockData() : ',
          email ||
            (this.$store.state.activeUser && this.$store.state.activeUser.email)
        );
      if (
        email === 'demo@triple-a.io' ||
        (!!this.$store.state.activeUser &&
          this.$store.state.activeUser.email === 'demo@triple-a.io')
      ) {
        if (debugConsole) window.console.warn('Using mock data');
        return true;
      }
      return false;
    },
    async wait(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },
    async sendMockData(data, ms = 2000) {
      await this.wait(ms);
      if (debugConsole) window.console.log('done waiting!');
      return Promise.resolve(data);
    },
    /**
     * Using the xpub address, get the ID of the wallet
     */
    addPub: function (
      pubkey,
      name,
      preferredCurrency,
      notificationEmail,
      accountType,
      apiId
    ) {
      const metadata = {};

      let data = {
        account_name: name,
        account_type: accountType, // ecommerce | donation | invoice
        currency: 'BTC', // only "BTC" supported currently
        local_currency: preferredCurrency,
        notification_email: notificationEmail,
        info: metadata, //JSON.stringify(metadata),
        wallet_type: null,
        return_url: '', // TODO !!!!!! ask for a webhook URL, and set the value
      };
      if (pubkey) {
        data.pub = pubkey;
      }
      if (apiId) {
        data.api_id = apiId;
      }
      if (!pubkey && !apiId) {
        if (debugConsole)
          console.error('Wrong input for addPub call', pubkey, apiId);
        return;
      }
      if (store.state.activeUser !== null && store.state.activeUser.userToken) {
        data.auth_token = store.state.activeUser.userToken;
      }
      data = JSON.stringify(data);
      if (debugConsole)
        console.debug('API: addPub(): request data for POST: ', data);

      const url = `${apiDomain}/add_pub`;
      return axios
        .post(url, data, {
          headers: {
            'Content-Type': 'application/application-json',
          },
        })
        .then(
          (result) => {
            if (debugConsole)
              console.log(
                `TripleA API : URL : ${url}`,
                JSON.stringify(result.data, null, 3)
              );
            // this.pub_id = result.data.hash;
            return result;
          },
          (error) => {
            // this.pub_id = null;
            if (debugConsole) console.error(error);
            return error;
          }
        );
    },
    /**
     *  Using the provided XPub key, fetches the linked transactions.
     */
    getTransactions(account) {
      // TODO this should be called by the store..data always served/cached by the store!

      let identifier;

      if (this.needsMockData()) {
        let txs = [];
        for (let i = 0; i < 60; i++) {
          let dateObj = new Date();
          dateObj.setDate(dateObj.getDate() - i);

          let maxj = Math.round(Math.random() * 20) + 20 - i / 10;

          for (let j = 0; j < maxj; j++) {
            dateObj.setHours(Math.round(Math.random() * 12));
            dateObj.setMinutes(Math.round(Math.random() * 59));
            let dateValue = Math.round(dateObj.valueOf() / 1000);

            let newTx = {
              address: '17iu9KjTmW1eg3w1QZ8NqpXCdB26mwa9RH',
              blocktime: dateValue,
              client_txid: null,
              confirmation: 1234,
              crdt_free: 0,
              crdt_pend: 0,
              created: dateValue,
              debit: 0,
              local_currency: 'USD',
              locked_rate_expired: false,
              locktime: 615165,
              payout_id: null,
              pyr_xchg_fee_amt: '0.0000',
              pyr_xchg_fee_base_amt: '0.0000',
              rate: 9312.005,
              rate_datetime: dateValue,
              rcv_base_amt: '605.3300',
              return_called_email: 1,
              return_called_payment_form: 0,
              return_called_url: 2,
              time: dateValue,
              to_ccy_amt: '605.3300',
              to_ccy_cd: 'USD',
              to_ccy_rt: '9312.0000000000',
              txid: '544143d32f5ab1bf1e853d225a0b60e0d524e11fb64458e89e1d4d1ed7c587ce',
              value: (Math.random() / 8).toFixed(8), // "0.06500581",
              withdrawal_id: null,
            };
            //if (i < 1 && j < 1) window.console.log('New TX : ', JSON.stringify(newTx, null, 3));

            txs.push(newTx);
          }
        }

        const mockData = {
          return: '0',
          status: 'OK',
          tx: txs,
          /*"tx" : [
            {
              "address" : "17iu9KjTmW1eg3w1QZ8NqpXCdB26mwa9RH",
              "blocktime" : 1580371099,
              "client_txid" : null,
              "confirmation" : 2836,
              "crdt_free" : 0,
              "crdt_pend" : 0,
              "created" : 1580371060,
              "debit" : 0,
              "local_currency" : "USD",
              "locked_rate_expired" : false,
              "locktime" : 615165,
              "payout_id" : null,
              "pyr_xchg_fee_amt" : "0.0000",
              "pyr_xchg_fee_base_amt" : "0.0000",
              "rate" : 9312.005,
              "rate_datetime" : 1580370817,
              "rcv_base_amt" : "605.3300",
              "return_called_email" : 1,
              "return_called_payment_form" : 0,
              "return_called_url" : 2,
              "time" : 1580371099,
              "to_ccy_amt" : "605.3300",
              "to_ccy_cd" : "USD",
              "to_ccy_rt" : "9312.0000000000",
              "txid" : "544143d32f5ab1bf1e853d225a0b60e0d524e11fb64458e89e1d4d1ed7c587ce",
              "value" : "0.06500581",
              "withdrawal_id" : null
            },

            ...

          ]*/
        };

        store.commit('UPDATE_ACCOUNT_TRANSACTIONS', {
          apiId: account.apiId,
          transactions: mockData.tx,
        });
        return this.sendMockData({ data: mockData }, 1000);
      }

      // When the user is not logged in, the only way to obtain transactions is by
      // providing the public key. The blockchain's own security.
      // If logged in, the authorization header will be set with the user token,
      // in which case we should provide the API ID. (This is so that we may decide to
      // remove the pubkey from browser memory entirely, might make a difference to privacy some day.)
      if (this.$store.state.activeUser === null) {
        identifier = account.pubkey;
      } else {
        identifier = account.apiId;
      }

      let url = `${apiDomain}/tx/${identifier}`;
      if (store.state.activeUser !== null && store.state.activeUser.userToken) {
        url = `${url}?auth_token=${store.state.activeUser.userToken}`;
      }
      //const data = {};

      const headers = {
        headers: {
          'Content-Type': 'application/application-json',
        },
      };

      return axios.get(url, headers).then(
        (result) => {
          if (debugConsole)
            console.log(
              `TripleA API : URL : ${url}`,
              JSON.stringify(result.data, null, 3)
            );
          let transactions = result.data.tx || [];

          store.commit('UPDATE_ACCOUNT_TRANSACTIONS', {
            apiId: identifier,
            transactions: transactions,
          });
          //console.log('triplea_api : updated account transactions', identifier, transactions);

          return result;
        },
        (error) => {
          if (debugConsole) console.error(error);
        }
      );
    },
    /**
     * Ask TripleA API to send an OTP to the specified e-mail address.
     */
    apiSendOTP: function () {
      const mockData = {
        return: '0',
        status: 'OK',
      };
      if (this.needsMockData()) {
        return this.sendMockData(mockData, 1000);
      }

      const url = `${apiDomain}/v1/dashboard/request-otp`;

      return axios
        .post(url, null, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then(
          (result) => {
            return result;
          },
          (error) => {
            // this.pub_id = null;
            if (debugConsole) console.error(error);
            return error.response;
          }
        );
    },
    /**
     * Ask TripleA API to send an OTP to the specified e-mail address.
     */
    apiCheckOTP: function (otp) {
      const mockData = {
        return: '0',
        status: 'OK',
        token: 'demo',
      };
      if (this.needsMockData()) {
        return this.sendMockData(mockData.token, 2000);
      }

      const data = {
        otp: otp,
      };

      const url = `${apiDomain}/v1/dashboard/verify-otp`;

      return axios
        .post(url, data, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then(
          (result) => {
            return result;
          },
          (error) => {
            if (debugConsole) console.error(error);
            return error.response;
          }
        );
    },
    apiPasswordVerify: function (clientId, username, password, recaptchaToken) {
      const params = new URLSearchParams();
      params.append('client_id', clientId);
      params.append('username', username);
      params.append('password', password);
      params.append('grant_type', 'password');
      params.append('recaptcha_token', recaptchaToken);
      if (store.state.otpKey) {
        params.append('otp_key', store.state.otpKey);
      } 
      if (store.state.otpValue) {
        params.append('otp', store.state.otpValue);
      }

      const url = `${apiDomain}/v1/oauth/token`;

      return Axios.post(url, params, {
        'Content-Type': 'application/x-www-form-urlencoded',
      }).then(
        (result) => {
          if (debugConsole) console.log('Result after login', result);
          // Save user token
          // let userAccount = {
          //   firstName: '',
          //   lastName: '',
          //   country: '',
          //   mobile: '',
          //   email: '',
          //   userToken: result.data.access_token,
          //   refreshToken: result.data.refresh_token,
          // };
          // this.$store.commit('LOGIN_USER_ACCOUNT', userAccount);
          return result;
        },
        (error) => {
          console.error('Error after login', error);
          return error.response;
        }
      );
    },
    emailPasswordVerify: async function (username, password) {
      let url = `${apiDomain}/v1/dashboard/account/verify`;
      let data = {
        username: username,
        password: password,
      };

      return Axios.post(url, data, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${store.state.activeUser.userToken}`,
        },
      }).then(
        (result) => {
          if (debugConsole) console.log('Result after login', result);
          return result;
        },
        (error) => {
          console.error('Error after login', error);
          return error.response;
        }
      );
    },
    apiPasswordLogin: function (clientId, username, password, recaptchaToken) {
      const mockData = {
        access_token: 'demo',
        token_type: 'Bearer',
        expires_in: 3599,
        refresh_token: 'demo',
      };
      if (this.needsMockData(username)) {
        return this.sendMockData(mockData, 2000);
      }

      const params = new URLSearchParams();
      params.append('client_id', clientId);
      params.append('username', username);
      params.append('password', password);
      params.append('grant_type', 'password');
      params.append('recaptcha_token', recaptchaToken);
      if (store.state.otpKey) {
        params.append('otp_key', store.state.otpKey);
      }
      if (store.state.otpValue) {
        params.append('otp', store.state.otpValue);
      }

      const url = `${apiDomain}/v1/oauth/token`; // TODO do this

      return axios
        .post(url, params, {
          headers: {
            //'Content-Type': 'application/application-json'
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        })
        .then(
          (result) => {
            if (debugConsole) console.log('Result after login', result);
            if (debugConsole)
              console.log(
                `TripleA API : URL : ${url}`,
                JSON.stringify(result.data, null, 3)
              );

            // Save user token
            let userAccount = {
              firstName: '',
              lastName: '',
              country: '',
              mobile: '',
              email: '',
              userToken: result.data.access_token,
              refreshToken: result.data.refresh_token,
            };
            this.$store.commit('LOGIN_USER_ACCOUNT', userAccount);

            return result.data;
          },
          (error) => {
            console.error('Error after login', error);
            // this.pub_id = null;
            return error.response;
          }
        );
    },
    doApiGetAccounts: function (result) {
      if (debugConsole)
        console.debug(
          'apiGetAccounts().then() : Received following data when requesting wallet accounts:',
          result.data
        );

      let accounts = [];
      if (result.data['accounts'] !== undefined) {
        for (let i = 0; i < (result.data.accounts || []).length; ++i) {
          let acc = result.data.accounts[i];

          if (debugConsole)
            console.debug(
              'apiGetAccounts().then() : Adding received account to store: ',
              JSON.stringify(acc)
            );

          accounts.push({
            apiId: acc.api_id,
            name: acc.account_name || 'no account name',
            settlementType: acc.settlement_type || acc.settlement_mode || '',
            accountType: acc.account_type || '',
            localCurrency: acc.local_currency,
            pubkey: acc.pubkey,
            //
            cryptoCurrency: acc.crypto_currency,
            receiveCryptoAmount: acc.receive_crypto_amount,
            receiveLocalAmount: acc.receive_local_amount,
            receiveBaseAmount: acc.receive_base_amount,
            payoutLocalAmount: acc.payout_local_amount,
            payoutBaseAmount: acc.payout_base_amount,
            refundLocalAmount: acc.refund_local_amount,
            refundBaseAmount: acc.refund_base_amount,
          });
        }
      }

      this.$store.commit('SET_ACCOUNTS', accounts);

      // if (firstAccountApiId) {
      //   if (debugConsole) console.debug('setting active account: ' + firstAccountApiId);
      //   this.$store.commit('SET_ACTIVE_ACCOUNT', firstAccountApiId);
      // }

      return accounts;
    },
    apiGetAccounts: function (activeUser) {
      if (activeUser === null) {
        if (debugConsole)
          console.debug('Error. No active user provided to apiGetAccounts().');
        return [];
      }

      if (this.needsMockData()) {
        const mockData = {
          accounts: [
            {
              account_name: 'Demo Account 1',
              account_type: 'ecommerce',
              api_id: 'HA1551367089BEEH_0',
              settlement_type: 'localcurrency',
              crypto_currency: 'BTC',
              local_currency: 'USD',
              receive_crypto_amount: 73.6161834,
              receive_local_amount: 604069.98,
              receive_base_amount: 604069.98,
              payout_local_amount: 601234.56,
              payout_base_amount: 601234.56,
              refund_local_amount: 0,
              refund_base_amount: 0,
            },
            {
              account_name: 'Demo Account 2',
              account_type: 'donations',
              api_id: 'HA1551367089BEEH_1',
              settlement_type: 'bitcoin',
              crypto_currency: 'BTC',
              local_currency: 'USD',
              receive_crypto_amount: 73.6161834,
              receive_local_amount: 604069.98,
              receive_base_amount: 604069.98,
              payout_local_amount: 601234.56,
              payout_base_amount: 601234.56,
              refund_local_amount: 0,
              refund_base_amount: 0,
            },
            {
              api_id: 'HA1551367089BEEH_2',
              account_name: 'Demo Account 3',
              account_type: 'ecommerce',
              settlement_type: 'localcurrency',
              local_currency: 'SGD',
              crypto_currency: 'BTC',
              receive_crypto_amount: 73.6161834,
              receive_local_amount: 604069.98,
              receive_base_amount: 604069.98,
              payout_local_amount: 601234.56,
              payout_base_amount: 601234.56,
              refund_local_amount: 0,
              refund_base_amount: 0,
            },
          ],
          return: '0',
          status: 'OK',
        };

        this.wait(2000);
        let accounts = this.doApiGetAccounts({ data: mockData });
        return this.sendMockData(accounts, 2000);
      }

      // There is an active user, which means a userToken will be set in the authorisation header.

      let pubkeys = [];
      for (let i = 0; i < (this.$store.state.accounts || []).length; ++i) {
        if (this.$store.state.accounts[i].pubkey) {
          pubkeys.push({
            pubkey: this.$store.state.accounts[i].pubkey,
            name: this.$store.state.accounts[i].name,
          });
        }
      }

      let data = {
        pubkeys: pubkeys,
      };
      data = JSON.stringify(data);

      const url = `${apiDomain}/v1/dashboard/accounts`;

      return axios
        .post(url, data, {
          headers: {
            'Content-Type': 'application/application-json',
            Authorization: `Bearer ${store.state.activeUser.userToken}`,
          },
        })
        .then(
          (result) => {
            if (
              !result.data ||
              result.data.status !== 'OK' ||
              result.data.return !== '0'
            ) {
              if (debugConsole)
                console.error('ERROR : get_accounts API call did not succeed.');
              return null;
            }
            if (debugConsole)
              console.log(
                `TripleA API : URL : ${url}`,
                JSON.stringify(result.data, null, 3)
              );

            return this.doApiGetAccounts(result);
          },
          (error) => {
            // this.pub_id = null;
            if (debugConsole) console.error(error);
            return error;
          }
        );
    },

    apiGetMerchants: async function () {
      let userToken = this.$store.state.activeUser.userToken;
      if (debugConsole)
        console.debug('User Token to get Merchants Data', userToken);

      if (!userToken) {
        return;
      }

      let url = `${apiDomain}/v1/dashboard/merchants`;
      const headers = {
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      };

      try {
        let result = await axios.get(url, headers);
        // console.log("Merchant results", result);
        this.$store.commit('SET_MERCHANTS', result.data);
        return result;
      } catch (err) {
        if (debugConsole) console.log('Error in getting Merchant Data', err);
        return;
      }

      // return axios.get(url,headers).then(result => {
      //     console.log("Merchant results", result);
      //    this.$store.commit("SET_MERCHANTS", result.data)
      // },error=> {
      //   console.log("Error in getting Merchant Data", error);
      // })
    },

    /**
     * Ask TripleA API for user profile data for the logged in user.
     */
    apiGetUserProfile: function () {
      let mockData = {
        country: 'SG',
        email: 'demo@triple-a.io',
        firstname: 'Demo',
        lastname: 'Account',
        mobile: '',
        return: '0',
        status: 'OK',
      };
      if (
        this.needsMockData() ||
        (store.state.activeUser !== null &&
          store.state.activeUser.userToken === 'demo')
      ) {
        return this.sendMockData(mockData, 2000);
      }

      if (debugConsole) console.debug('apiGetUserProfile()');

      let url = `${apiDomain}/v1/dashboard/profile`;

      return Axios
        .get(url, {
          headers: {
            Authorization: `Bearer ${store.state.activeUser.userToken}`,
          },
        })
        .then(
          (result) => {
            if (
              !result ||
              !result.data ||
              result.data.status !== 'OK' ||
              result.data.return !== '0'
            ) {
              return null;
            }
            return result.data;
          }
        ).catch((err) => {
          throw err;
        });
    },
    /**
     * Sends updated user profile data to the TripleA API.
     */

    apiUpdatePassword: async function (oldPass, newPass) {
      let data = {
        old_password: oldPass,
        new_password: newPass,
      };
      if (store.state.activeUser !== null && store.state.activeUser.userToken) {
        data.auth_token = store.state.activeUser.userToken;
      }
      data = JSON.stringify(data);

      //  console.debug('API: apiUpdatePassword(): request data for POST: ', JSON.stringify(data, null, 2));

      const url = `${apiDomain}/v1/dashboard/profile/password/change`;

      try {
        let result = await axios.post(url, data, {
          'Content-Type': 'application/application-json',
          Authorization: `Bearer ${store.state.activeUser.userToken}`,
        });
        // console.log('Result success on change password', result)
        return result;
      } catch (err) {
        if (debugConsole) console.log('Error on change password', err);
        return err;
      }

      // return axios.post(url, data, {
      //   'Content-Type': 'application/application-json',
      //   'Authorization': `Bearer ${store.state.activeUser.userToken}`
      // }).then(result => {
      //   console.log(`TripleA API : URL : ${url}`, JSON.stringify(result.data, null, 3));

      // console.debug('Received updated user password: ', result);

      //   if (result.data.status !== 'OK' || result.data.return !== '0')
      //   {
      //      console.error('Updating user password failed.');

      //     // TODO display error message

      //     return;
      //   }

      //   return result;

      // },
      // error=> {
      //   if (debugConsole) console.error(error);
      //       return error;
      // })
    },

    apiUpdateUserProfile: function (firstName, lastName, country, mobile) {
      if (this.needsMockData()) {
        // For demo account, we don't allow updates, obviously.
        return;
      }

      let data = {
        firstname: firstName,
        lastname: lastName,
        country: country,
        mobile: mobile,
      };
      if (store.state.activeUser !== null && store.state.activeUser.userToken) {
        data.auth_token = store.state.activeUser.userToken;
      }
      data = JSON.stringify(data);

      if (debugConsole)
        console.debug(
          'API: apiUpdateUserProfile(): request data for POST: ',
          JSON.stringify(data, null, 2)
        );

      const url = `${apiDomain}/update_profile`;

      return axios
        .post(url, data, {
          headers: {
            'Content-Type': 'application/application-json',
          },
        })
        .then(
          (result) => {
            if (debugConsole)
              console.log(
                `TripleA API : URL : ${url}`,
                JSON.stringify(result.data, null, 3)
              );

            if (debugConsole)
              console.debug('Received updated user profile: ', result);

            if (result.data.status !== 'OK' || result.data.return !== '0') {
              if (debugConsole) console.error('Updating user profile failed.');

              // TODO display error message

              return;
            }

            // store.commit('UPDATE_USER_PROFILE', {
            //   firstName: result.data.firstName || '',
            //   lastName: result.data.lastName || '',
            //   country: result.data.country || '',
            //   mobile: result.data.mobile || '',
            // });

            store.commit('UPDATE_USER_PROFILE', {
              firstName: firstName || '',
              lastName: lastName || '',
              country: country || '',
              mobile: mobile || '',
            });

            return result;
          },
          (error) => {
            if (debugConsole) console.error(error);
            return error;
          }
        );
    },
    /**
     *
     *
     * @param activeAccount
     * @returns {Promise<AxiosResponse<any> | never>|null}
     */
    apiGetBankAccount: function (activeAccount) {
      if (activeAccount === null || !activeAccount.apiId) {
        if (debugConsole)
          console.error(
            'Error. No active account provided, or missing API ID.'
          );
        return null;
      }

      const data = JSON.stringify({
        apiId: activeAccount.apiId,
      });

      const url = `${apiDomain}/bank_accounts`;

      return axios
        .get(url, data, {
          headers: {
            'Content-Type': 'application/application-json',
          },
        })
        .then(
          (result) => {
            if (
              !result.data ||
              result.data.status !== 'OK' ||
              result.data.return !== '0'
            ) {
              if (debugConsole)
                console.error(
                  'ERROR : GET bank_accounts API call did not succeed.'
                );
              return null;
            }
            if (debugConsole)
              console.log(
                `TripleA API : URL : ${url}`,
                JSON.stringify(result.data, null, 3)
              );
            if (debugConsole)
              console.debug(
                'GET bank_accounts for API ID ' + activeAccount.apiId + ' : ',
                result.data
              );

            // if (certain condition?)
            // this.$store.commit('SET_WALLET_BANK_ACCOUNT', activeAccount.apiId);

            return result.data;
          },
          (error) => {
            if (debugConsole) console.error(error);
            return error;
          }
        );
    },
    /**
     * Convert the amount to
     */
    exchange(fromCurrency, toCurrency, amount) {
      // console.debug('Exchange using this url : ', `${apiDomain}/exchange/${fromCurrency.toUpperCase()}/${toCurrency.toUpperCase()}/${amount}`);

      return axios.get(
        `${apiDomain}/exchange/${fromCurrency.toUpperCase()}/${toCurrency.toUpperCase()}/${amount}`
      );
    },
    /**
     * Send the XPub key, receive a crypto payment address in return.
     */
    setAddr: function (apiId, notificationEmail, invoiceNumber) {
      const data = JSON.stringify({
        api_id: apiId,
        // xpub_id: this.pub_id,
        // expiration: 7200,
        return_email: notificationEmail ? notificationEmail : null,
        // return_url_one: null, // process.env.DEV_SERVER + '/return_url/',
        // return_url_two: null, // process.env.DEV_SERVER + '/return_url/',
        // return_url_three: null, // process.env.DEV_SERVER + '/return_url/',
        client_txid: invoiceNumber ? invoiceNumber : null,
      });

      const url = `${apiDomain}/set_addr`;

      return axios
        .post(url, data, {
          headers: {
            'Content-Type': 'application/application-json',
          },
        })
        .then(
          (result) => {
            if (debugConsole)
              console.log(
                `TripleA API : URL : ${url}`,
                JSON.stringify(result.data, null, 3)
              );
            // console.log('setAddr response: ', result.data.addr, result);
            if (result.data.addr) {
              // this.paymentAddress = result.data.addr;
            } else {
              this.paymentAddressError = 'error: invalid payment address';
              //Promise.reject("Could not obtain payment address.");
              throw new Error("Profile doesn't exist");
            }

            return result;
          },
          (error) => {
            if (debugConsole) console.error(error);
          }
        )
        .catch(function (e) {
          if (debugConsole) console.log(e); // calling it as a method, btw
          return null;
        });
    },
    /**
     * Provide a BTC address, and check the balance of that account.
     */
    balance(paymentAddress) {
      const url = `${apiDomain}/balance/${paymentAddress}`;

      return axios.get(url).then((result) => {
        if (debugConsole)
          console.log(
            `TripleA API : URL : ${url}`,
            JSON.stringify(result.data, null, 3)
          );
        // console.log('balance result', result);

        return result;
      });
    },
    apiGetPayouts(account) {
      let apiId = account.apiId;
      let url = `${apiDomain}/v1/dashboard/account/${apiId}/payouts`;
      let data = null;

      if (store.state.activeUser !== null && store.state.activeUser.userToken) {
        url = `${url}`;
      } else {
        return null;
      }

      return axios
        .get(url, data, {
          headers: {
            'Content-Type': 'application/application-json',
            Authorization: `Bearer ${store.state.activeUser.userToken}`,
          },
        })
        .then(
          (result) => {
            if (
              !result.data ||
              result.data.data === undefined ||
              result.data.meta === undefined
            ) {
              if (debugConsole)
                console.error(
                  'apiGetPayouts() ERROR : payouts API call did not succeed.'
                );
              return null;
            }
            if (debugConsole)
              console.log(
                `TripleA API : URL : ${url}`,
                JSON.stringify(result.data, null, 3)
              );

            return result.data;
          },
          (error) => {
            if (debugConsole) console.error(error);
            return error;
          }
        );
    },
    postUserInfo(fieldName, fieldValue, paymentAddress) {
      // Send email (and name, optional) of user that pays this bill.
      let data = {
        info: fieldName + ':' + fieldValue,
        addr: paymentAddress,
      };

      const url = `${apiDomain}/addr_info`;

      return axios
        .post(url, data, {
          headers: {
            'Content-Type': 'application/application-json',
          },
        })
        .then(
          (result) => {
            if (result.data.status.toLowerCase() !== 'ok') {
              throw new Error('Error submitting user info');
            }
            if (debugConsole)
              console.log(
                `TripleA API : URL : ${url}`,
                JSON.stringify(result.data, null, 3)
              );
            return result;
          },
          (error) => {
            if (debugConsole) console.warn('Error', error);
            return error;
          }
        );
    },

    apiSignUpNewUser(firstname, lastname, email, phoneNum) {
      const params = new URLSearchParams();
      params.append('firstname', firstname);
      params.append('lastname', lastname);
      params.append('email', email);
      params.append('mobile', phoneNum);

      const url = `${apiDomain}/v1/dashboard/profile`;

      return axios
        .post(url, params, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        })
        .then((result) => {
          return result;
        })
        .catch((error) => {
          if (debugConsole) console.log('Error', error);
          return error;
        });
    },

    async apiRequestResetPassword(email) {
      const url = `${apiDomain}/v1/dashboard/profile/password/reset/request`;
      const data = {
        email: email,
      };
      try {
        let result = await axios.post(url, data, {
          headers: {
            'Content-Type': 'application/json',
          },
        });
        if (debugConsole) console.log('Result from Resetting Password', result);
        return result;
      } catch (err) {
        window.console.error('Error in Resetting Password', err);
        return err;
      }
    },

    async apiResetPassword(token, newPassword) {
      const url = `${apiDomain}/v1/dashboard/profile/password/reset`;
      const data = {
        token: token,
        password: newPassword,
      };

      try {
        let result = await axios.post(url, data, {
          'Content-Type': 'application/json',
        });
        return result;
      } catch (err) {
        console.error(err);
        return err.response;
      }
    },

    async getRefundToken(merchantKey) {
      let url = `${apiDomain}/v1/dashboard/merchant/${merchantKey}/token`;

      let accessToken = this.$store.state.activeUser.userToken;

      try {
        let result = await axios.post(url, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });
        if (debugConsole)
          window.console.log('Result from Getting Refund token', result);
        return result;
      } catch (err) {
        window.console.error('Error in Getting a Refund Token', err);
        throw err;
      }
    },

    async createRefund(refundData, isLocalCurrencySettlementType) {
      let url;

      if(isLocalCurrencySettlementType) {
        url = `${apiDomain}/v1/dashboard/merchant/${refundData.merchant_key}/refund/local`;
      } else {
        url = `${apiDomain}/v1/payout/refund/custody`;
      }
      let data = refundData;

      try {
        let result = await Axios.post(url, data, {
          headers: {
            Authorization: `Bearer ${this.$store.state.activeUser.userToken}`,
            'Content-Type': 'application/json',
            'recaptcha-token': refundData.recaptcha_token,
          },
        });
        if (debugConsole)
          window.console.log('Result from creating a refund', result);
        return result;
      } catch (err) {
        window.console.error('Error in creating a refund', err);
        throw err;
      }
    },
    // async createRefundCustody(token, refundData) {
    //   let url = `${apiDomain}/v1/payout/refund/custody`;

    //   let refundToken = token;
    //   let data = refundData;

    //   try {
    //     let result = await Axios.post(url, data, {
    //       headers: {
    //         Authorization: `Bearer ${refundToken}`,
    //         'Content-Type': 'application/json',
    //       },
    //     });
    //     if (debugConsole)
    //       window.console.log('Result from creating a refund', result);
    //     return result;
    //   } catch (err) {
    //     window.console.error('Error in creating a refund', err);
    //     throw err;
    //   }
    // },

    async getMerchantToken(merchantKey) {
      let url = `${apiDomain}/v1/dashboard/merchant/${merchantKey}/token`;

      let accessToken = this.$store.state.activeUser.userToken;

      try {
        let result = await axios.post(url, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });
        if (debugConsole)
          window.console.log('Result from getting withdrawal token', result);
        return result;
      } catch (err) {
        window.console.error('Error in getting a refund token', err);
        throw err;
      }
    },

    async createWithdrawalLocalToCrypto(withdrawalData) {
      const merchantKey = withdrawalData.merchant_key;
      const url = `${apiDomain}/v1/dashboard/merchant/${merchantKey}/payouts/local-crypto`;

      const data = withdrawalData;
      const accessToken = this.$store.state.activeUser.userToken;

      try {
        const result = await Axios.post(url, data, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
            'recaptcha-token': data.recaptchaToken,
          },
        });
        if (debugConsole) window.console.log('Withdraw result', result);
        return result;
      } catch (err) {
        window.console.error('Error in withdrawal result', err);
        throw err;
      }
    },

    async createWithdrawalCustody(withdrawalData) {
      const merchantKey = withdrawalData.merchant_key;
      const url = `${apiDomain}/v1/dashboard/merchant/${merchantKey}/payouts/custody-crypto`;

      const data = withdrawalData;
      const accessToken = this.$store.state.activeUser.userToken;

      try {
        const result = await Axios.post(url, data, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
            'recaptcha-token': data.recaptchaToken,
          },
        });
        if (debugConsole) window.console.log('Withdraw result', result);
        return result;
      } catch (err) {
        window.console.error('Error in withdrawal result', err);
        throw err;
      }
    },

    async payoutCancellation(payoutReference, data) {
      let url = `${apiDomain}/v1/dashboard/merchant/${data.merchantKey}/payouts/${payoutReference}/cancel`;

      let payload = data;

      if (debugConsole) console.log('Data in payout cancelled', data);

      try {
        let result = await Axios.put(url, payload, {
          headers: {
            Authorization: `Bearer ${this.$store.state.activeUser.userToken}`,
            'recaptcha-token': data.recaptchaToken,
          },
        });
        return result;
      } catch (err) {
        window.console.error('Error in cancelling payout', err);
        throw err;
      }
    },
    // async getExchangeRateToUSD(data)
    // {
    //   // let apiId = data.apiId;
    //   let fiatCurrency = data.fiatCurrency;
    //   let amount = data.amount;
    //
    //   // console.log("API ID", apiId);
    //   if(debugConsole) console.log("Fiat Currency", fiatCurrency);
    //   if(debugConsole) console.log("Amount", amount);
    //
    //   let url = `${apiDomain}/exchange/${fiatCurrency}/USD/${amount}`
    //
    //   try {
    //     let result = await Axios.get(url);
    //     if(debugConsole) console.log("Result for Exchange Rate", result);
    //     return result;
    //   }catch(err)
    //   {
    //     console.error("Error in getting exchange rate");
    //     throw err;
    //   }
    // },

    async getExchangeRateToUSD(data) {
      let apiId = data.apiId;
      let fiatCurrency = data.fiatCurrency;
      // let amount = data.amount;

      if (debugConsole) console.log('API ID', apiId);
      if (debugConsole) console.log('Fiat Currency', fiatCurrency);
      // if(debugConsole) console.log("Amount", amount);

      let url = `${apiDomain}/v1/exchange_rate/${apiId}/USD/${fiatCurrency}`;

      try {
        let result = await Axios.get(url);
        if (debugConsole) console.log('Result for Exchange Rate', result);
        return result;
      } catch (err) {
        console.error('Error in getting exchange rate');
        throw err;
      }
    },

    async getExchangeRateAPI(data) {
      let apiId = data.apiId;
      let orderCurrency = data.orderCurrency;
      let paymentCurrency = data.paymentCurrency;
      // let amount = data.amount;

      if (debugConsole) console.log('API ID', apiId);
      if (debugConsole) console.log('Order Currency', orderCurrency);
      if (debugConsole) console.log('Payment Currency', paymentCurrency);
      // if(debugConsole) console.log("Amount", amount);

      let url = `${apiDomain}/v1/exchange_rate/${apiId}/${orderCurrency}/${paymentCurrency}`;

      try {
        let result = await Axios.get(url);
        if (debugConsole) console.log('Result for Exchange Rate', result);
        return result;
      } catch (err) {
        console.error('Error in getting exchange rate');
        throw err;
      }
    },

    async getRecipientDetails(token, data) {
      let email = data.email;

      let url = `${apiDomain}/v2/payee/${email}`;

      // let accessToken = this.$store.state.activeUser.userToken;

      if (debugConsole) console.log('Token', token);

      let payload = {};
      payload.merchant_key = data.merchant_key;

      try {
        let result = await Axios.post(url, payload, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        return result;
      } catch (err) {
        if (debugConsole)
          window.console.error("Error in getting recipient's details", err);
        throw err;
      }
    },

    async getS3DataForPayeePOIUpload(payload) {
      let accessToken = this.$store.state.activeUser.userToken;

      let url = `${apiDomain}/v1/dashboard/payee_poi/upload`;
      const headers = {
        Authorization: `Bearer ${accessToken}`,
      };

      let data = {};
      data.mime_type = payload.mimeType;
      data.merchant_key = payload.merchantKey;

      return axios.post(url, data, headers).then(
        (res) => {
          if (debugConsole) console.log('Get S3 Data', res);
          return res;
        },
        (err) => {
          throw err;
        }
      );
    },

    uploadPayeePOI(payload) {
      if (!payload) {
        console.debug('No payload');
        return;
      }

      let s3Data = payload.s3Data;
      let contentType = payload.contentType;
      let file = payload.file;
      let fields = s3Data.fields;

      let url = s3Data.url;

      const headers = {
        Authorization: undefined,
      };

      let formData = new FormData();

      for (const [key, value] of Object.entries(fields)) {
        formData.append(key, value);
      }

      // formData.append("key", s3Data.fields["key"])
      // formData.append("X-Amz-Algorithm", s3Data.fields["X-Amz-Algorithm"]);
      // formData.append("X-Amz-Credential", s3Data.fields["X-Amz-Credential"]);
      // formData.append("X-Amz-Date", s3Data.fields["X-Amz-Date"]);
      // formData.append("X-Amz-Signature", s3Data.fields["X-Amz-Signature"]);
      // formData.append("Policy", s3Data.fields["Policy"]);
      formData.append('Content-Type', contentType);
      formData.append('file', file);

      if (debugConsole) console.log('Form Data', formData);

      // based on Axios from npm lib package, so headers need to be in object.
      return Axios.post(url, formData, headers).then(
        (res) => {
          // if (debugConsole) console.log("Upload payee POI successful", res);
          return res;
        },
        (err) => {
          if (debugConsole) console.log('Error in upload payee POI', err);
          throw err;
        }
      );
    },

    async revokeAccessToken(checkForExpiry) {
      const payload = {
        token: store.state.activeUser.userToken,
        ...(checkForExpiry && { expired: checkForExpiry }),
      };

      let config = {
        method: 'post',
        url: `${apiDomain}/v2/oauth/revoke`,
        headers: {
          Authorization: `Bearer ${store.state.activeUser.userToken}`,
          'Content-Type': 'application/json',
        },
        data: JSON.stringify(payload),
      };

      await Axios(config)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          if (err.response.status === 401) {
            // token already revoked
            this.$store.commit('LOGOUT_USER_ACCOUNT');
            this.$router.push('/login');
          }
          throw err;
        });
    },

    //check if OTP is required in Login
    async checkLoginOTP(payload) {
      let url = `${apiDomain}/v1/dashboard/login-request-otp`;

      try {
        let result = await axios.post(url, payload);
        if (result.data.mfa_type === MFA_TYPE.EMAIL) {
          store.commit('UPDATE_OTP_KEY', result.data.otp_key);
        }
        return result;
      } catch (err) {
        if (debugConsole) console.log('Error when requesting OTP');
        return err;
      }
    },

    // verify the login
    async verifyLoginOTP(payload) {
      let url = `${apiDomain}/v1/dashboard/login-verify-otp`;
      store.commit('UPDATE_OTP_VALUE', payload.otp); // saving OTP value

      try {
        let result = await axios.post(url, payload);
        if (debugConsole) console.log('Verify OTP Result', result);
        return result;
      } catch (err) {
        //  console.log("Error in verifying OTP");
        return err;
      }
    },

    apiResetSecret(merchantKey) {
      // 'https://integ.triple-a.io/api/v1/dashboard/merchant/{{merchant_key}}/reset-client-secret'
      return axios
        .put(
          `${apiDomain}/v1/dashboard/merchant/${merchantKey}/reset-client-secret`
        )
        .then(
          (result) => {
            if (!result || result.status !== 200) {
              return null;
            }
            return result.status;
          },
          (error) => {
            // console.log(error)
            return error;
          }
        );
    },

    async apiCreateCredentials(key, otp) {
      // 'https://integ.triple-a.io/api/v1/dashboard/merchant/:mcnt_key/api-credentials'
      const userToken = this.$store.state.activeUser.userToken;
      if (!userToken) {
        return;
      }
      let url = '';
      if (key.startsWith('pid-')) {
        // partner
        url = `${apiDomain}/v1/dashboard/partner/${key}/api-credentials`;
      } else {
        url = `${apiDomain}/v1/dashboard/merchant/${key}/api-credentials`;
      }

      const headers = {
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      };

      const payload = {
        otp_pin: otp,
      };

      return axios
        .post(url, payload, headers)
        .then((result) => {
          this.$store.commit('SET_API_CREDENTIALS', [
            ...this.$store.state.apiCredentials,
            ...result.data,
          ]);
          return result;
        })
        .catch((err) => {
          console.error(err);
          return err.response;
        });
    },

    async apiDeleteCredentials(key, otp, clientId) {
      const userToken = this.$store.state.activeUser.userToken;
      if (!userToken) {
        return;
      }
      let url = '';
      if (key.startsWith('pid-')) {
        // partner
        url = `${apiDomain}/v1/dashboard/partner/${key}/api-credentials`;
      } else {
        url = `${apiDomain}/v1/dashboard/merchant/${key}/api-credentials`;
      }

      const headers = {
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      };

      const payload = {
        otp_pin: otp,
        client_id: clientId,
      };

      return axios.delete(url, { data: payload, ...headers });
    },

    async apiGetCredentials(key) {
      const userToken = this.$store.state.activeUser.userToken;
      if (!userToken) {
        return;
      }
      let url = '';
      if (key.startsWith('pid-')) {
        // partner
        url = `${apiDomain}/v1/dashboard/partner/${key}/api-credentials`;
      } else {
        url = `${apiDomain}/v1/dashboard/merchant/${key}/api-credentials`;
      }

      const headers = {
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      };

      try {
        let result = await axios.get(url, headers);
        this.$store.commit('SET_API_CREDENTIALS', result.data);
        return result;
      } catch (err) {
        if (debugConsole) console.log('Error in getting API credentials', err);
        return;
      }
    },

    /**
     * Used for the readonly access. Uses the one-time code to get the user token.
     * @param {*} code
     */
    getTokenWithCode(code) {
      const url = `${apiDomain}/v2/oauth/token`;
      const headers = {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      };
      const params = new URLSearchParams();
      const oacid = process.env.VUE_APP_LOCAL_ENV ? process.env.VUE_APP_CLIENT_ID_LOCAL : process.env.VUE_APP_CLIENT_ID;
      params.append('client_id', oacid);
      params.append('code', code);
      params.append('grant_type', 'authorization_code');
      params.append('redirect_uri', DASHBOARD_URL);

      return axios.post(url, params, headers);
    },

    async apiApprovePayout(payoutRef) {
      let userToken = this.$store.state.activeUser.userToken;
      if (debugConsole)
        console.debug('User Token to approve payout', userToken);

      if (!userToken) {
        return;
      }

      let url = `${apiDomain}/v1/dashboard/payout/${payoutRef}/approve`;
      const headers = {
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      };

      let result = await axios.post(url, {}, headers);
      return result;
    },

    // Generate QR code from the URL provided in the response
    async qrCodeForAuthenticatorRegistration() {
      const userToken = this.$store.state.activeUser.userToken;
      const url = `${apiDomain}/v1/dashboard/authenticator`;

      const headers = {
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      };
      return await Axios.post(url, {}, headers);
    },

    // register and verify first OTP
    async registerAndVerifyOTP(otp) {
      const userToken = this.$store.state.activeUser.userToken;
      const url = `${apiDomain}/v1/dashboard/authenticator/register`;

      const payload = {
        otp: otp,
      };

      const headers = {
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      };
      return await Axios.put(url, payload, headers);
    },

    logoutUser(check = false) {
      this.revokeAccessToken(check)
        .then(() => {
          this.$store.commit('LOGOUT_USER_ACCOUNT');
          this.$router.push('/login');
        })
        .catch((e) => {
          if (e.response.status === 401) {
            // token already expired, proceed with logout
            this.$store.commit('LOGOUT_USER_ACCOUNT');
            this.$router.push('/login');
          }
        });
    },
  },
});
